export const OVERLAY = Symbol('overlay');
export const SEARCH = Symbol('search');

export const events = {
  [OVERLAY]: {
    CLICK: 'click',
  },
  [SEARCH]: {
    OPEN: 'open',
    CLOSE: 'close',
    KEYDOWN_ARROW_DOWN: 'keydownArrowDown',
  },
};
